<template>
    <form class="suggest-reminders-form form-horizontal" @submit.prevent="submit()">
        
        <div class="form-group">
    
            <label class="sr-only" for="filter">Escribe aquí la tarjeta que buscas</label>
            <div class="input-group">
                <input
                    type="text"
                    id="filter"
                    class="form-control"  v-model="searchText" 
                    placeholder="Escribe aquí la tarjeta que buscas"
                />
                <div class="input-group-btn">
                    <button class="btn btn-primary" type="submit" @click.prevent="search"    >
                        <i class="fa fa-search"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="form-group">
            <div style="text-align:center">
                <ul  class="pagination pagination2" >
                    <li ><a  v-if="page != 1" @click="page--" role="button">Prev</a></li>
                    <li v-for="pageNumber in pages" :key="pageNumber"><a @click="page = pageNumber" role="button">{{pageNumber}}</a></li>
                  
                    <li><a  @click="page++" v-if="page < pages.length" role="button">Next</a></li>
                </ul>
            </div>
        </div>
        <div class="form-group">
            <div class="panel panel-default">
                <div class="panel-heading">
                    <h3 class="panel-title">Recordatorios</h3>
                </div>
                <div class="panel-body">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Acción</th>
                                <th>Id Ficha</th>
                                <th>Nombre del trámite</th>
                                <th>Título recordatorio</th>
                                <th>Tipo Recordatorio</th>
                                <th>Evento Inicia</th>
                                <th>Evento Finaliza</th>
                                <th>Visible en Portada</th>
                                <th>Destacar en MiChileAtiende</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="r in displaydReminders " :key="r.id">
                                <td><a :href="'backend/fichas/'+ r.page_id + '/reminders/'+r.id +'/edit'" title="Editar Recordatorio"><i class="material-icons">edit</i></a></td>
                                <td>{{ r.page_id }}</td>
                                <td>{{ r.page.title }}</td>
                                <td>{{ r.title }}</td>
                                <td>{{ r.tipo }}</td>
                                <td>{{ moment(r.start_date) }}</td>
                                <td>{{ moment(r.due_date)}}</td>
                                <td>
                                    <el-switch
                                        v-model="r.publish_portal"
                                        on-text="SI"
                                        off-text="NO"
                                        @change="okChange"
                                        >
                                    </el-switch>
                                </td>
                                <td>
                                    <el-switch
                                        v-model="r.suggest"
                                        on-text="SI"
                                        off-text="NO"
                                        @change="okChange"
                                        >
                                    </el-switch>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
         <div class="form-group">
            <div style="text-align:center">
                <ul  class="pagination pagination2" >
                    <li ><a  v-if="page != 1" @click="page--">Prev</a></li>
                    <li v-for="pageNumber in pages " :key="pageNumber"><a @click="page = pageNumber">{{pageNumber}}</a></li>
                  
                    <li><a  @click="page++" v-if="page < pages.length" >Next</a></li>
                </ul>
            </div>
        </div>
        <div v-if="showbutton" class="form-group">
            <div class="col-sm-offset-5 col-sm-7">
                <a class="btn btn-default" @click="cancel"  >Cancelar</a>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>
</template>
<style scoped>

</style>
<script>
import ElementUI from 'element-ui';
import ElSwitch from 'element-ui/lib/switch';
import { Message } from 'element-ui';


export default {

    data: function(){
        const data = _.cloneDeep(this.reminders);

        return{
            data:data,
            showbutton: false,
            searchText:'',
			page: 1,
			perPage: 20,
			pages: [],
        }

    },
    props:['reminders'],
    computed:{
        displaydReminders: function(){
            this.setPages();
            return this.paginate(this.data);
        }
    },
    watch:{
        data:function(){
            this.setPages();
        }
    },
    methods:{
        moment: function (date) {
            return moment(date).format("DD/MM/YYYY") ;
        },
        okChange: function(){
            var ok = false;
            var oks = false;
            var x = 0;

            this.data.forEach(e => {
                var rbd =this.reminders.find(r=> r.id == e.id);
   
                if(e.publish_portal != rbd.publish_portal || e.suggest != rbd.suggest)
                    ok = true;
 
            }); 
            this.showbutton = ok;
        },
        cancel: function(){
            this.showbutton = false;
            
            this.data.forEach(e => {
                var rbd =this.reminders.find(r=> r.id == e.id);
   
                e.publish_portal = rbd.publish_portal;
                e.suggest = rbd.suggest;
            }); 
        },
        submit:function(){
            var self = this;

            
            axios({
                url: 'backend/mantenedor-recordatorios/sugerir',
                method: 'POST',
                data: { reminders : self.data} ,
            }).then(function(response){
                window.location.replace(response.data.redirect);
            }).catch(function(error){
                self.errors = error.response.data.errors;
            });
        },
        search:function(){
            var self = this;

            window.location.href ='/backend/mantenedor-recordatorios?search='+self.searchText;
 
        },
        setPages :function() {
            
            let numberOfPages = Math.ceil(this.data.length / this.perPage);
 
            if(numberOfPages != this.pages.length)
                for (let index = 1; index <= numberOfPages; index++) {
                    this.pages.push(index);
                }
            
            
		},
		paginate:function (pages) {
			let page = this.page;
			let perPage = this.perPage;
			let from = (page * perPage) - perPage;
            let to = (page * perPage);
            
			return  pages.slice(from, to);
		}
    }

}
</script>